const images = [
    { url: '/images/1.png' },
    { url: '/images/2.png' },
    { url: '/images/3.png' },
    { url: '/images/4.png' },
    { url: '/images/5.png' },
    { url: '/images/6.png' },
    { url: '/images/7.png' },
    { url: '/images/8.png' },

    // { url: '/images/img11.webp' },
    // { url: '/images/img12.webp' },
    // { url: '/images/img13.webp' },
];

export default images;
